import { ObjectTypes, Services } from '@diligentcorp/rc-service-object-mapping';

export function getServiceForObjectType(objectType: string): string {
  switch (objectType) {
    case ObjectTypes.EVIDENCE:
    case ObjectTypes.CONTROL:
    case ObjectTypes.CONTROL_ASSESSMENT:
      return Services.INTERNAL_CONTROLS;
    case ObjectTypes.PROCESS:
    case ObjectTypes.OBJECTIVE:
    case ObjectTypes.RISK:
    case ObjectTypes.RISK_MITIGATION:
    case ObjectTypes.RISK_EVENT_ASSESSMENT:
      return Services.RISK_MANAGER;
    case ObjectTypes.ASSET_HARDWARE:
    case ObjectTypes.ASSET_SOFTWARE:
    case ObjectTypes.ASSET_CLOUD:
    case ObjectTypes.ASSET_INFORMATION_SYSTEM:
    case ObjectTypes.ASSET_THIRD_PARTY:
      return Services.ASSET_MANAGER;
    default:
      throw new Error(
        `Unsupported object type for service resolution: ${objectType}`,
      );
  }
}
